const sameId = (left, right) => String(left) === String(right);
const partyItems = (transaction, partyId, role) =>
  (transaction?.review?.items || []).filter(
    item =>
      sameId(item.target_key, partyId) && item.section?.startsWith(`${role}_`)
  );

const sectionByCheck = {
  'dados pessoais': 'personal',
  endereco: 'address',
  procurador: 'attorney',
  procuracao: 'attorney',
  documentos: 'documents',
  'documentos da empresa': 'documents',
  'dados da empresa': 'company',
};

const normalize = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .trim();

const sectionForCheck = check => {
  const name = normalize(check.name || check.nome || check);
  if (name.startsWith('procuracao')) return 'attorney';

  return sectionByCheck[name];
};

export const salesPartyReviewContext = ({
  partyId,
  relationType,
  role,
  transaction,
}) => {
  const participant = (transaction?.participants || []).find(
    party => sameId(party.id, partyId) && party.role === role
  );
  const items = partyItems(transaction, partyId, role);
  const parentParty = (transaction?.participants || []).find(party =>
    sameId(party.id, participant?.parent_party_id)
  );
  const checks = items.flatMap(item => item.checks || []);
  const sectionChecks = checks.reduce((groups, check) => {
    const section = sectionForCheck(check);
    if (section) groups[section] = [...(groups[section] || []), check];
    return groups;
  }, {});

  return {
    checks,
    hasCorrections: checks.length > 0,
    items,
    observation: items.find(item => item.observation)?.observation || '',
    parentParty,
    participant,
    relationType: relationType || participant?.relation_type || 'principal',
    section: items[0]?.section || '',
    sectionChecks,
  };
};

export const shouldShowSalesPartyReview = route =>
  route.query?.return_to === 'review' && Boolean(route.params.partyId);
